export const eventRoles = ["CONVIDADO", "PALESTRANTE", "IMPRENSA", "STAFF", "OUTRO"];
